// import deviceMonitoring from '../../api/DeviceMonitoringService'
import deviceMonitoring from '@/api/DeviceMonitoringService'
const state ={
    loader: false,
    deviceMonitorData:[],
    initialData:{},
    deviceData:{},
    getProcessedData:[],
    unRegisteredData:[]
    // devicedata: [
    //     {
    //       imei: 12155111111,
    //       simNumber: 999999999,
    //       deviceType: "GPS",
    //       vehicleNumber: "KA456J",
    //       sensor: "FUEL",
          
    //     },
    //     {
    //       imei: 2222222222222,
    //       simNumber: 8888888888,
    //       deviceType: "GPS",
    //       vehicleNumber: "KA456J",
    //       sensor: "FUEL",
    //     },
    //     {
    //       imei: 33333333333,
    //       simNumber: 7777777777,
    //       deviceType: "sss",
    //       vehicleNumber: "KA456J",
    //       sensor: "FUEL",
    //     },
    //     {
    //       imei: 4444444444444,
    //       simNumber: 6666666666666,
    //       deviceType: "ffffwwer",
    //       vehicleNumber: "KA456J",
    //       sensor: "FUEL",
    //     },
    //     {
    //       imei: 55555555555555,
    //       simNumber: 55555555555555555,
    //       deviceType: "GPS",
    //       vehicleNumber: "KA456J",
    //       sensor: "FUEL",
    //     },
    //     {
    //       imei: 1166666666666666666,
    //       simNumber: 444444444,
    //       deviceType: "GPS",
    //       vehicleNumber: "KA456J",
    //       sensor: "FUEL",
    //     },
    //   ],
    //   deatilComponentData:[
    //     {
    //       lastRawData:"Gps sensor",
    //       lastProcessedData:"device id45544"
    //     }
    //   ]
}
const getters = {
     deviceMonitorData : state => state.deviceMonitorData,
     getInitialData : state => state.initialData,
     getProcessedData : state => state.getProcessedData,
     unRegisteredData : state =>state.unRegisteredData
}
const actions = {
   async getDeviceMonitoringData({ commit,state }){
         state.loader = true;
        const res = await deviceMonitoring.getDeviceMonitorData();
        state.deviceData = res;
        state.loader = false;
       commit("getDeviceMonitorData", res.data)
    },
    async getInitialData({commit, state}) {
      state.loader=true
      const response = await deviceMonitoring.getInitialData();
      state.loader=false
      commit('getInitialData', response.data)
  },
  async getUnRegisteredData({state,commit}){
    state.loader=true
    const response = await deviceMonitoring.getUnRegisteredData();
    state.loader=false;
    commit("getUnregisteredData" , response.data)
  },
  async acknowledgeDeviceMonitorData({state,dispatch},deviceId){
    state.loader=true;
    await deviceMonitoring.acknowledgeDeviceMonitorData(deviceId);
    state.loader=false;
    dispatch('getDeviceMonitoringData')
  },
  async acknowledgeUnRegisterData({state,dispatch},deviceId){
    state.loader=true;
    await deviceMonitoring.acknowledgeUnRegisterData(deviceId);
    state.loader=false;
    dispatch('getUnRegisteredData')
  }
}
const mutations ={
  getDeviceMonitorData(state,devicemonitorData){
    state.deviceMonitorData = devicemonitorData
  },
  getInitialData(state,initialData){
  state.initialData = initialData
  },
  getUnregisteredData(state,unRegisteredData){
    state.unRegisteredData = unRegisteredData
  }
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}